<script setup lang="ts">
defineProps<{
  metrics: {
    label: string;
    value: string;
    unit?: string;
    status?: "default" | "positive" | "warning" | "danger";
  }[];
}>();

const statusClass: Record<string, string> = {
  default: "text-type-default",
  positive: "text-app-green-700",
  warning: "text-app-yellow-700",
  danger: "text-app-red-700",
};
</script>

<template>
  <div
    v-if="metrics.length"
    class="gap-px-8 flex flex-wrap">
    <div
      v-for="metric in metrics"
      :key="metric.label"
      class="chat-metric-card gap-px-4 rounded-8 p-px-12 flex min-w-[120px] flex-1 flex-col border">
      <span class="chat-text-muted t-caption">{{ metric.label }}</span>
      <span
        class="t-small-bold"
        :class="statusClass[metric.status ?? 'default']">
        {{ metric.value }}
      </span>
      <span
        v-if="metric.unit"
        class="chat-text-muted t-caption">
        {{ metric.unit }}
      </span>
    </div>
  </div>
  <p
    v-else
    class="chat-text-muted t-caption">
    No metrics available
  </p>
</template>
